import { useTranslation } from 'next-i18next'

const useOccasionsMap = () => {
  const { t } = useTranslation()
  const KEY = 'venue.requestForm.secondStep'

  return new Map([
    ['team_event', t(`${KEY}.occasionList.teamEvent`)],
    ['all_hands', t(`${KEY}.occasionList.allHands`)],
    ['customer_event', t(`${KEY}.occasionList.customerEvent`)],
    ['leadership', t(`${KEY}.occasionList.leadership`)],
    ['one_day', t(`${KEY}.occasionList.oneDay`)],
    ['workation', t(`${KEY}.occasionList.workation`)],
    ['other', t(`${KEY}.occasionList.other`)],
  ])
}

export default useOccasionsMap
